import React from 'react';
import "@fortawesome/fontawesome-free/css/all.css";
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));